import { render, staticRenderFns } from "./redeemPoints.vue?vue&type=template&id=08d9d57f"
import script from "./redeemPoints.vue?vue&type=script&lang=js"
export * from "./redeemPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports